<template>
    <!-- Footer START -->
    <footer class="content-footer">
        <div class="footer">
            <div class="copyright">
                <span>© Tous droits réservés - <b>Kemtag</b> 2018</span>
                <span class="go-right">
                    <!--<a href="" class="text-gray mrg-right-15">CGU</a>
                    <a href="" class="text-gray">Privacy</a>  mettre le lien dans href-->
                    <a class="text-gray mrg-right-15">CGU</a>
                    <a class="text-gray">Privacy</a>
                </span>
            </div>
        </div>
    </footer>
    <!-- Footer END -->
</template>

<script>
    export default {
        name: "Footer"
    }
</script>